<template>
  <PForm
    nested
    :schema="r$"
    :validate-on="['blur', 'input']"
    class="model-edit-form-machine flex flex-col"
  >
    <div class="primary-lighten-1 flex w-full flex-col gap-y-2 rounded-md p-2">
      <PFormField sr-only label="Machinenaam" name="name">
        <PInput v-model="machine.name" placehoder="Machinenaam" ref="inputName" />
      </PFormField>
    </div>
  </PForm>
</template>

<script setup lang="ts">
import PForm from "@/components/form/PForm.vue"
import { computed, watchEffect, inject, onMounted, ref } from "vue"
import { useRegle } from "@regle/core"
import PFormField from "@/components/form/PFormField.vue"
import PInput from "@/components/form/PInput.vue"
import { requiredValidator } from "@/helper/validation/validators"
import { useFormConfigurator } from "@/composables/form/form-configurator"
import { Machine } from "@/models/machine.model"
import { MachineController } from "@/controllers/model-controllers/machine-controller"
import { upperFirst } from "lodash-es"
import { formFocusHack } from "@/helper/form-helper"

const controller: MachineController = inject("machineController")!

const { model: machine, initialText, isFormInvalid } = useFormConfigurator<Machine>({ controller })

const inputName = ref()
onMounted(() => {
  if (initialText) {
    machine.value.name = upperFirst(initialText)
  }
  formFocusHack(inputName, machine, "name")
})
const rules = {
  name: { requiredValidator } // todo not exist
}

const { r$ } = useRegle(
  computed(() => ({ name: machine.value.name })),
  rules,
  { autoDirty: false }
)

watchEffect(() => {
  isFormInvalid.value = r$.$invalid
})
</script>

<style scoped></style>
